<template>
    <div v-if="dataLoaded && survey">
        <template v-if="survey.studentSurvey.completedAt === null">
            <h3 class="mb-3">Responder Encuesta/Quiz:</h3>
            <h2 class="mb-4 text-center"><strong>{{ survey.name }}</strong></h2>
            <p>
                <strong>Duración Máxima: </strong>
                <span v-if="survey.durationMinutes > 0">{{ survey.durationMinutes }} minutos.</span>
                <span v-else>Indefinida.</span>
            </p>
            <p v-if="survey.description" class="display-breaks text-justify">
                <strong>Descripción: </strong><br />
                {{ survey.description }}
            </p>

            <h4>Preguntas</h4>
            <hr />

            <b-container v-if="dataLoaded" fluid>
                <b-row
                    v-if="!canStartSurvey"
                    align-h="center"
                >
                    <b-col sm="6">
                        <b-button
                            variant="primary"
                            size="lg"
                            block
                            class="my-1 px-4"
                            @click="onCompleteSurvey()"
                        >
                            <b-icon-check2-all /> Enviar {{ operativeWord }}
                        </b-button>
                    </b-col>
                </b-row>
                <b-row
                    v-if="canStartSurvey"
                    align-h="center"
                >
                    <b-col sm="6">
                        <b-button
                            variant="success"
                            size="lg"
                            block
                            class="my-4 px-4"
                            @click="onStartSurvey()"
                        >
                            <b-icon-card-checklist /> Iniciar {{ operativeWord }}
                        </b-button>
                    </b-col>
                </b-row>
                <template v-else >
                    <SurveyTimer
                        v-if="survey.durationMinutes"
                        :starttime="new Date(Date.now()).toISOString()"
                        :endtime="survey.studentSurvey.submitBefore"
                        @timer-expired="onConfirmCompleteSurvey()"
                    />
                    <SurveyQuestion
                        v-for="(question, index) in survey.questions"
                        :key="`question-${question.id}`"
                        :question="question"
                        :number="index + 1"
                    />
                </template>
                <b-row
                    v-if="!canStartSurvey"
                    align-h="center"
                >
                    <b-col sm="6">
                        <b-button
                            variant="primary"
                            size="lg"
                            block
                            class="my-4 px-4"
                            @click="onCompleteSurvey()"
                        >
                            <b-icon-check2-all /> Enviar {{ operativeWord }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </template>

        <template v-else>
            <h3 class="mb-3">Respuestas de Encuesta/Quiz:</h3>
            <h2 class="mb-4 text-center"><strong>{{ survey.name }}</strong></h2>
            <p>
                <strong>Duración Máxima: </strong>
                <span v-if="survey.durationMinutes > 0">{{ survey.durationMinutes }} minutos.</span>
                <span v-else>Indefinida.</span>
            </p>
            <p v-if="survey.description" class="display-breaks text-justify">
                <strong>Descripción: </strong><br />
                {{ survey.description }}
            </p>

            <h4>Respuestas</h4>
            <hr />
            <div
                class="mb-2"
                style="min-height: 30px; font-size: 1rem;"
            >
                <span v-if="survey.isEvaluated">
                    Ponderación Obtenida:
                    <strong>{{ survey.studentSurvey.totalValueDisplay }} %</strong>
                </span>
            </div>
            <b-container v-if="dataLoaded" fluid>
                <SurveyAnswer
                    v-for="(question, index) in survey.questions"
                    :key="`question-${question.id}`"
                    :question="question"
                    :number="index + 1"
                />
            </b-container>
        </template>

    </div>
</template>

<script>
import SurveyAnswer from './components/SurveyAnswer'
import SurveyQuestion from './components/SurveyQuestion'
import SurveyTimer from './components/SurveyTimer'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'StudentsSurveyDetail',
    components: {
        SurveyQuestion,
        SurveyTimer,
        SurveyAnswer
    },
    data () {
        return {
            dataLoaded: false
        }
    },
    computed: {
        ...mapState({
            activeSite: 'activeSite',
            survey: 'selectedSurveyObject'
        }),
        ...mapGetters([
            'isUserStudentInCurrentSite'
        ]),
        canStartSurvey () {
            if (this.survey && this.survey.studentSurvey.startedAt === null) {
                return true
            }
            return false
        },
        operativeWord () {
            if (this.survey && this.survey.isEvaluated) {
                return 'Quiz'
            }
            return 'Encuesta'
        }
    },
    methods: {
        ...mapActions([
            'readSingleBasicStudentSurvey',
            'readSingleWholeStudentSurvey',
            'readStudentSurveyAnswers',
            'startStudentSurvey',
            'completeStudentSurvey'
        ]),
        async loadwholeSurveyData () {
            this.$store.commit('RESET_SELECTED_SURVEY_OBJECT')
            let loader = this.$loading.show()
            this.dataLoaded = false
            try {
                var payload = { courseSiteId: this.activeSite.id, surveyId: this.$route.params.surveyId }
                await this.readSingleBasicStudentSurvey(payload)
                if (this.canGoToDetailPage(this.survey)) {
                    if (this.survey && this.survey.studentSurvey.completedAt !== null) {
                        // If the survey was completed and the student can see the detail page
                        // display the corrent and incorrect answers
                        await this.readStudentSurveyAnswers(payload)
                        this.dataLoaded = true
                    } else {
                        // Else just display the form to answer the questions.
                        if (!this.canStartSurvey) {
                            // Read all the data of the survey if the survey has already started
                            await this.readSingleWholeStudentSurvey(payload)
                        }
                        this.dataLoaded = true
                    }
                } else {
                    this.$router.replace({ name: 'site-student-surveys-list' })
                }
            } catch (err) {
                console.log(err)
                if (err.response && (err.response.status === 404 || err.response.status === 403)) {
                    // If the survey does not exists or the user is not part of the teaching staff
                    // Redirect the user to the site general info section
                    this.$router.replace({ name: 'site-general-info' })
                } else {
                    this.$root.unknownErrorToast()
                }
                this.dataLoaded = false
            } finally {
                loader.hide()
            }
        },
        canGoToDetailPage (survey) {
            if (
                survey.studentSurvey.completedAt === null ||
                (survey.studentSurvey.completedAt !== null && survey.showAnswers && survey.isEvaluated)
            ) {
                return true
            }
            return false
        },
        async onStartSurvey () {
            if (this.survey.durationMinutes > 0) {
                try {
                    let value = await this.$bvModal.msgBoxConfirm(
                        `Esta encuesta/quiz posee una duración máxima de ${this.survey.durationMinutes} minuto(s). ¿Esta seguro que desea iniciar la encuesta/quiz e iniciar el tiempo?`,
                        {
                            title: 'Confirmar',
                            okVariant: 'success',
                            okTitle: 'Iniciar',
                            cancelTitle: 'Cancelar',
                            centered: true
                        }
                    )
                    if (value) {
                        await this.onConfirmStartSurvey()
                    }
                } catch (error) {
                    console.log({ error: error })
                    this.unknownErrorToast()
                }
            } else {
                await this.onConfirmStartSurvey()
            }
        },
        async onConfirmStartSurvey () {
            let loader = this.$loading.show()
            try {
                var payload = { courseSiteId: this.activeSite.id, studentSurveyId: this.survey.studentSurvey.id }
                await this.startStudentSurvey(payload)
            } catch (err) {
                console.log(err)
                if (err.response && (err.response.status === 404 || err.response.status === 403)) {
                    // If the survey does not exists or the user is not part of the teaching staff
                    // Redirect the user to the site general info section
                    this.$router.replace({ name: 'site-general-info' })
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                loader.hide()
            }
        },
        async onCompleteSurvey () {
            try {
                let value = await this.$bvModal.msgBoxConfirm('¿Esta seguro que desea completar y enviar la encuesta/quiz?', {
                    title: 'Confirmar',
                    okVariant: 'primary',
                    okTitle: 'Enviar',
                    cancelTitle: 'Cancelar',
                    centered: true
                })
                if (value) {
                    await this.onConfirmCompleteSurvey()
                }
            } catch (error) {
                console.log({ error: error })
            }
        },
        async onConfirmCompleteSurvey () {
            let loader = this.$loading.show()
            try {
                const payloadData = { courseSiteId: this.activeSite.id, studentSurveyId: this.survey.studentSurvey.id }
                await this.completeStudentSurvey(payloadData)
                this.$router.push({ name: 'site-student-surveys-list' })
                this.$root.infoToast(`La encuesta/quiz se ha enviado exitosamente. Gracias por su participación.`)
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo enviar la encuesta/quiz, intente más tarde.')
            } finally {
                loader.hide()
            }
        }
    },
    async created () {
        await this.loadwholeSurveyData()
    }
}
</script>
